export const OCEAN_SUNSET_LIGHT = {
  name: 'Ocean Sunset',
  mode: 'light',
  bg: '#F4F1EB',
  surface: '#FFFFFF',
  border: '#D9D2C4',
  borderLight: '#E9E3D6',
  text: '#001219',
  textSecondary: '#3A4A4D',
  textTertiary: '#7A8A8D',
  dataBlue: '#005F73',
  dataNavy: '#0A9396',
  dataSteel: '#94D2BD',
  dataSky: '#EE9B00',
  dataSlate: '#CA6702',
  coral: '#BB3E03',
  green: '#0A9396',
  red: '#AE2012',
  blueLight: '#E0EEF1',
  navyLight: '#DFF3F3',
  steelLight: '#EAF6F0',
  skyLight: '#FDF3E0',
  slateLight: '#FBF0E2',
  coralLight: '#FDEEE5',
  greenLight: '#DFF3F3',
  redLight: '#FBEAE7',
  amberLight: '#FDF3E0',
  ice: '#E0EEF1',
  barTrack: '#E9E3D6',
  hoverBg: 'rgba(0,95,115,0.04)',
  apiNoteBg: 'rgba(0,95,115,0.04)',
  apiNoteBorder: 'rgba(0,95,115,0.12)',
  badgeBg: '#E0EEF1',
  badgeText: '#005F73',
  toggleBg: '#D9D2C4',
  tooltipShadow: 'rgba(0,18,25,0.08)',
  badge: '#005F73',
  hover: 'rgba(0,95,115,0.04)',
  tooltip: '#001219',
};

export const OCEAN_SUNSET_DARK = {
  name: 'Ocean Sunset Dark',
  mode: 'dark',
  bg: '#001219',
  surface: '#002028',
  border: '#003544',
  borderLight: '#003544',
  text: '#E9D8A6',
  textSecondary: '#94D2BD',
  textTertiary: '#5B8A84',
  dataBlue: '#0A9396',
  dataNavy: '#94D2BD',
  dataSteel: '#E9D8A6',
  dataSky: '#EE9B00',
  dataSlate: '#CA6702',
  coral: '#CA6702',
  green: '#94D2BD',
  red: '#AE2012',
  blueLight: 'rgba(10,147,150,0.16)',
  navyLight: 'rgba(148,210,189,0.14)',
  steelLight: 'rgba(233,216,166,0.12)',
  skyLight: 'rgba(238,155,0,0.14)',
  slateLight: 'rgba(202,103,2,0.12)',
  coralLight: 'rgba(202,103,2,0.16)',
  greenLight: 'rgba(148,210,189,0.16)',
  redLight: 'rgba(174,32,18,0.16)',
  amberLight: 'rgba(238,155,0,0.16)',
  ice: 'rgba(10,147,150,0.20)',
  barTrack: '#003544',
  hoverBg: 'rgba(10,147,150,0.08)',
  apiNoteBg: 'rgba(10,147,150,0.06)',
  apiNoteBorder: 'rgba(10,147,150,0.18)',
  badgeBg: 'rgba(10,147,150,0.16)',
  badgeText: '#0A9396',
  toggleBg: '#003544',
  tooltipShadow: 'rgba(0,18,25,0.25)',
  badge: '#0A9396',
  hover: 'rgba(10,147,150,0.08)',
  tooltip: '#E9D8A6',
};

export const CHART_HEADER = {
  inkBlack: '#001219',
  wheat: '#E9D8A6',
};

export const VIEW_BADGES = {
  executive: '#005F73',
  organization: '#0A9396',
  team: '#EE9B00',
  individual: '#94D2BD',
};

export const RADIUS = {
  xs: 5,
  sm: 6,
  md: 10,
  lg: 15,
  xl: 18,
};

export const SPACING = {
  xs: 5,
  sm: 10,
  md: 12,
  base: 15,
  lg: 20,
  xl: 22,
  '2xl': 28,
  '3xl': 32,
  '4xl': 48,
};

export const DATA_RAMP = ['#005F73', '#0A9396', '#94D2BD', '#EE9B00', '#CA6702', '#BB3E03', '#AE2012', '#9B2226'];

export const COLOR_KEYS = {
  blue:       '#005F73',
  navy:       '#0A9396',
  steel:      '#94D2BD',
  sky:        '#EE9B00',
  slate:      '#CA6702',
  deepNavy:   '#003049',
  mint:       '#2A9D8F',
  terracotta: '#BB3E03',
  wine:       '#9B2226',
  goldenrod:  '#7F5900',
  violet:     '#6D597A',
  dim:        '#9B9B9B',
};

export const COLOR_KEYS_DARK = {
  blue:       '#0A9396',
  navy:       '#94D2BD',
  steel:      '#E9D8A6',
  sky:        '#EE9B00',
  slate:      '#CA6702',
  deepNavy:   '#48CAE4',
  mint:       '#76C893',
  terracotta: '#F77F00',
  wine:       '#E05C60',
  goldenrod:  '#F4C430',
  violet:     '#B399C9',
  dim:        '#9B9B9B',
};

export const PRODUCT_META = [
  { key: 'chat', colorKey: 'blue' },
  { key: 'claude_code', colorKey: 'navy' },
  { key: 'cowork', colorKey: 'steel' },
  { key: 'office_agent', colorKey: 'sky' },
  { key: 'claude_in_chrome', colorKey: 'slate' },
  { key: 'claude_in_slack', colorKey: 'slate' },
  { key: 'claude_in_xcode', colorKey: 'slate' },
  { key: 'research', colorKey: 'violet' },
  { key: 'other', colorKey: 'dim' },
];

export const RESERVED_PRODUCT_COLOR_KEYS = new Set(['violet', 'dim']);

export function pickColorKeys(mode) {
  return mode === 'dark' ? COLOR_KEYS_DARK : COLOR_KEYS;
}

export function buildRankedProductColorMap({ sortedKeys, dataRamp, colorKeys, meta = PRODUCT_META }) {
  const metaByKey = Object.fromEntries(meta.map((m) => [m.key, m]));
  const colorMap = {};
  const usedColors = new Set();

  sortedKeys.forEach((key) => {
    const colorKeyName = metaByKey[key]?.colorKey;
    if (colorKeyName && RESERVED_PRODUCT_COLOR_KEYS.has(colorKeyName)) {
      const reserved = colorKeys?.[colorKeyName];
      if (reserved) {
        colorMap[key] = reserved;
        usedColors.add(reserved);
      }
    }
  });

  let rampIdx = 0;
  sortedKeys.forEach((key) => {
    if (colorMap[key]) return;
    let color = dataRamp[rampIdx % dataRamp.length];
    let guard = 0;
    while (usedColors.has(color) && guard < dataRamp.length) {
      rampIdx += 1;
      color = dataRamp[rampIdx % dataRamp.length];
      guard += 1;
    }
    colorMap[key] = color;
    usedColors.add(color);
    rampIdx += 1;
  });

  return colorMap;
}

export const MODEL_META = [
  { key: 'opus48',   label: 'Opus 4.8',    colorKey: 'deepNavy'    },
  { key: 'opus47',   label: 'Opus 4.7',    colorKey: 'terracotta'  },
  { key: 'opus46',   label: 'Opus 4.6',    colorKey: 'blue'        },
  { key: 'opus45',   label: 'Opus 4.5',    colorKey: 'wine'        },
  { key: 'sonnet5',  label: 'Sonnet 5',    colorKey: 'mint'        },
  { key: 'sonnet50', label: 'Sonnet 5.0',  colorKey: 'mint'        },
  { key: 'sonnet46', label: 'Sonnet 4.6',  colorKey: 'navy'        },
  { key: 'sonnet45', label: 'Sonnet 4.5',  colorKey: 'goldenrod'   },
  { key: 'sonnet35', label: 'Sonnet 3.5',  colorKey: 'steel'       },
  { key: 'haiku45',  label: 'Haiku 4.5',   colorKey: 'sky'         },
  { key: 'haiku35',  label: 'Haiku 3.5',   colorKey: 'slate'       },
  { key: 'other',    label: 'Other',       colorKey: 'dim'         },
];

export const COST_TYPE_META = [
  { key: 'tokens', label: 'Token inference', colorKey: 'blue' },
  { key: 'web_search', label: 'Web search', colorKey: 'sky' },
  { key: 'code_execution', label: 'Code execution', colorKey: 'navy' },
  { key: 'other', label: 'Other', colorKey: 'dim' },
];

function buildLegacyAliases(tokens) {
  return {
    blue: tokens.dataBlue,
    navy: tokens.dataNavy,
    sky: tokens.dataSky,
    amber: tokens.dataSky,
    slate: tokens.dataSlate,
    steel: tokens.dataSteel,
    primary: tokens.dataBlue,
    secondary: tokens.dataNavy,
    background: tokens.bg,
    backgroundSecondary: tokens.mode === 'light' ? tokens.borderLight : tokens.border,
    sidebarGradient:
      tokens.mode === 'light'
        ? `linear-gradient(180deg, ${tokens.bg} 0%, ${tokens.borderLight} 100%)`
        : `linear-gradient(180deg, ${tokens.surface} 0%, ${tokens.border} 100%)`,
    logoGradient: `linear-gradient(135deg, ${tokens.dataBlue} 0%, ${tokens.dataNavy} 100%)`,
    menuHover:
      tokens.mode === 'light'
        ? `linear-gradient(135deg, ${tokens.hoverBg} 0%, ${tokens.borderLight} 100%)`
        : `linear-gradient(135deg, ${tokens.hoverBg} 0%, ${tokens.border} 100%)`,
    menuSelected: `linear-gradient(135deg, ${tokens.dataBlue} 0%, ${tokens.dataNavy} 100%)`,
    border: tokens.border,
    textPrimary: tokens.text,
    textSecondary: tokens.textSecondary,
    textIcon: tokens.textTertiary,
    shadow: tokens.tooltipShadow,
    shadowStrong:
      tokens.mode === 'light'
        ? 'rgba(0,18,25,0.16)'
        : 'rgba(0,18,25,0.50)',
    contentBg: tokens.bg,
    headerBg: tokens.surface,
    cardBg: tokens.surface,
    text: tokens.text,
    bg: tokens.bg,
    tableValueAccent: tokens.text,
  };
}

export function buildThemeObject(tokens) {
  return {
    ...tokens,
    ...buildLegacyAliases(tokens),
    colorKeys: pickColorKeys(tokens.mode),
  };
}
